import { NonReportedError, sendErrorEmailGraphql } from '@otuvy/ionic-react-common';
import { graphql } from '../../utils/api/apiUtils';
import packageJson from '../../../package.json';

//Re-export for convenience
export { NonReportedError };

export const excludedErrorMessages = ['Network error'];

export const sendErrorEmail = async (subject: string, body?: string) => {
  sendErrorEmailGraphql({
    subject,
    body,
    appName: packageJson.name,
    appVersion: packageJson.version,
    graphql,
  });
};
